import { render, staticRenderFns } from "./OnSitePaymentInfo.vue?vue&type=template&id=06143de4"
import script from "./OnSitePaymentInfo.vue?vue&type=script&lang=ts"
export * from "./OnSitePaymentInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports